
export const SearchTypes = Object.freeze({
    book: 'book',
    chapter: 'chapter',
});
